/**
 * CCM19's `acceptedCookies` is a getter that reads its consent cookie. Safari
 * throws `SecurityError: The operation is insecure.` from it when the page may
 * not use storage (blocked cookies, some private and in-app modes), so every
 * read goes through here and treats that as no consent.
 */
export const readAcceptedCookies = (): string[] => {
  if (typeof window === 'undefined') return [];
  try {
    return window.CCM?.acceptedCookies || [];
  } catch {
    return [];
  }
};

const MARKETING_COOKIES = ['_fbp', '_fbc', 'fr'];

export const hasMarketingConsent = (): boolean => {
  const accepted = readAcceptedCookies();
  if (!accepted.length) return false;
  return MARKETING_COOKIES.some((name) =>
    accepted.some((cookie) => cookie.toLowerCase() === name)
  );
};
